/**
 * AUTO-GENERATED FILE - DO NOT EDIT MANUALLY
 * Generated by: scripts/generate-template-loaders.js
 * Source files:
 *   - corporate.njk
 *   - corporate.css
 */

export const CORPORATE_TEMPLATE = `<div class="card">
  <div class="accent-bar"></div>

  <!-- Header -->
  <div class="hdr">
    <div class="hdr-left">
      <div class="store-name">{{ storeName }}</div>
      <div class="store-info">
        {% if address %}{{ address | replace('\\n', '<br/>') | safe }}{% endif %}
        {% if phone %}<br/>Tel: {{ phone }}{% endif %}
      </div>
    </div>
    <div class="hdr-right">
      <div class="inv-label">Tax Invoice</div>
      <div class="inv-number"># {{ orderNo }}</div>
      <div class="inv-date">{{ dateStr }}&nbsp;{{ timeStr }}</div>
    </div>
  </div>

  <!-- Bill To / Meta -->
  <div class="meta-grid">
    <div class="meta-block">
      <p class="meta-title">Bill To</p>
      <p style="font-weight:600">{{ customerName }}</p>
      {% if customerPhone %}<p><span class="sub">Tel: </span>{{ customerPhone }}</p>{% endif %}
      {% if customerAddress %}<p><span class="sub">Addr: </span>{{ customerAddress }}</p>{% endif %}
    </div>
    <div class="meta-block" style="text-align:right">
      <p class="meta-title">Order Info</p>
      <p><span class="sub">Type: </span>{{ sellingType }}</p>
      <p><span class="sub">Status: </span>{{ orderStatus }}</p>
    </div>
  </div>

  <!-- Body -->
  <div class="body">
    <!-- Items Table -->
    <table>
      <thead>
        <tr>
          <th align="left">Description</th>
          <th align="center" style="width:{{ is80 and '11%' or '9%' }}">Qty</th>
          <th align="right" style="width:{{ is80 and '24%' or '17%' }}">Unit Price</th>
          {% if not is80 %}<th align="right" style="width:15%">Discount</th>{% endif %}
          <th align="right" style="width:{{ is80 and '28%' or '18%' }}">Amount</th>
        </tr>
      </thead>
      <tbody>
        {% for item in items %}
        <tr>
          <td>
            <div class="td-name">{{ item.product_name or item.item_name or "Product" }}</div>
            {% if item.batch_no %}<div class="td-batch">Batch: {{ item.batch_no }}</div>{% endif %}
          </td>
          <td align="center">{{ item.quantity }}</td>
          <td align="right">{{ currency }} {{ item.price | formatPrice }}</td>
          {% if not is80 %}
          <td align="right" style="color:{% if item.discount_amount > 0 %}#c53030{% else %}#a0aec0{% endif %}">
            {% if item.discount_amount > 0 %}-{{ currency }} {{ item.discount_amount | formatPrice }}{% else %}-{% endif %}
          </td>
          {% endif %}
          <td align="right" style="font-weight:600">{{ currency }} {{ item.total_price | formatPrice }}</td>
        </tr>
        {% endfor %}
      </tbody>
      <tfoot>
        <tr>
          <td colspan="{{ is80 and '3' or '4' }}" align="right" style="color:#4a5568">Subtotal</td>
          <td align="right">{{ currency }} {{ subtotal | formatPrice }}</td>
        </tr>
      </tfoot>
    </table>

    <!-- Payment Section -->
    {% if payments.length > 0 %}
    <div class="pay-section">
      <p class="pay-title">Payments Received</p>
      {% for p in payments %}
      <div class="pay-item">
        <span class="pay-chip">{{ p.payment_method_name or p.payment_method_code or "Payment" }}</span>
        <span style="font-weight:600">{{ currency }} {{ p.amount | formatPrice }}</span>
      </div>
      {% endfor %}
    </div>
    {% endif %}

    <!-- Totals -->
    <div class="totals-wrap">
      <div class="totals-box">
        {% if showDisc %}
        <div class="t-row disc"><span>Discount</span><span>- {{ currency }} {{ discountAmount | formatPrice }}</span></div>
        {% endif %}
        {% if showExch %}
        <div class="t-row disc"><span>Exchange Discount</span><span>- {{ currency }} {{ exchangeAmount | formatPrice }}</span></div>
        {% endif %}
        {% if showChg %}
        <div class="t-row"><span>Other Charges</span><span>{{ currency }} {{ otherCharges | formatPrice }}</span></div>
        {% endif %}
        <div class="t-row grand"><span>Total Due</span><span>{{ currency }} {{ grandTotal | formatPrice }}</span></div>
        <div class="t-row paid"><span>Amount Paid</span><span>{{ currency }} {{ paidAmount | formatPrice }}</span></div>
        <div class="t-row {{ hasDue and 'due' or 'paid' }}"><span>Balance</span><span>{{ currency }} {{ dueAmount | formatPrice }}</span></div>
      </div>
    </div>
  </div>

  <!-- Footer -->
  <div class="ftr">
    <p>{{ footer }}</p>
    <p class="powered">Powered by TaproDev POS</p>
  </div>
</div>
`;

export const CORPORATE_CSS = `@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');

*, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

body {
  font-family: 'Inter', system-ui, -apple-system, sans-serif;
  font-size: var(--inv-font, 13.5px);
  color: #1a202c;
  background: var(--inv-bg, #edf2f7);
  padding: var(--inv-body-pad, 28px 20px);
  -webkit-print-color-adjust: exact;
  print-color-adjust: exact;
}

.card {
  width: var(--inv-width, 210mm);
  max-width: 100%;
  margin: 0 auto;
  background: #fff;
  border-radius: var(--inv-radius, 6px);
  overflow: hidden;
  box-shadow: var(--inv-shadow, 0 2px 20px rgba(0,0,0,0.09));
  border: var(--inv-card-border, none);
}

.accent-bar {
  height: var(--inv-accent-h, 7px);
  background: linear-gradient(90deg, #0d7377 0%, #14a085 50%, #0d7377 100%);
}

.hdr {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  padding: var(--inv-hdr-pad, 22px 32px 18px);
  border-bottom: 1px solid #e2e8f0;
  flex-wrap: wrap;
}

.store-name { font-size: var(--inv-store-size, 1.55em); font-weight: 700; color: #0d7377; letter-spacing: -0.3px; line-height: 1.15; margin-bottom: 4px; }
.store-info { font-size: var(--inv-store-sub, 0.82em); color: #718096; line-height: 1.6; }
.hdr-right  { text-align: right; flex-shrink: 0; }

.inv-label  { font-size: var(--inv-inv-lbl, 0.7em); font-weight: 700; text-transform: uppercase; letter-spacing: 2px; color: #0d7377; margin-bottom: 3px; }
.inv-number { font-size: var(--inv-inv-num, 1.35em); font-weight: 700; color: #1a202c; letter-spacing: 0.3px; }
.inv-date   { font-size: var(--inv-inv-date, 0.8em); color: #718096; margin-top: 3px; }

.meta-grid {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  padding: var(--inv-meta-pad, 16px 32px);
  border-bottom: 1px solid #e2e8f0;
  background: #f7fafc;
}

.meta-title { font-size: var(--inv-meta-title, 0.65em); font-weight: 700; text-transform: uppercase; letter-spacing: 1.5px; color: #a0aec0; margin-bottom: 5px; }
.meta-block p { font-size: var(--inv-meta-p, 0.88em); color: #2d3748; line-height: 1.6; }
.meta-block p .sub { color: #718096; }

.body { padding: var(--inv-body-pad-in, 28px 32px); }

table { width: 100%; border-collapse: collapse; margin-bottom: var(--inv-tbox-mb, 18px); font-size: var(--inv-tbl-size, 0.9em); }
thead tr { background: #0d7377; }
thead th { padding: var(--inv-th-pad, 10px 12px); color: #fff; font-weight: 600; font-size: var(--inv-th-size, 0.75em); text-transform: uppercase; letter-spacing: 0.7px; }
tbody tr { border-bottom: 1px solid #edf2f7; }
tbody tr:nth-child(even) { background: #f7fafc; }
tbody td { padding: var(--inv-td-pad, 10px 12px); color: #2d3748; vertical-align: top; }
.td-name  { font-weight: 500; color: #1a202c; }
.td-batch { font-size: 0.78em; color: #a0aec0; margin-top: 2px; }
tfoot tr  { background: #edf2f7; border-top: 2px solid #0d7377; }
tfoot td  { padding: var(--inv-td-pad, 10px 12px); font-weight: 600; color: #1a202c; }

.totals-wrap { display: flex; justify-content: flex-end; margin-bottom: var(--inv-tbox-mb, 18px); }
.totals-box  { width: var(--inv-tbox-w, 55%); border: 1px solid #e2e8f0; border-radius: 6px; overflow: hidden; }

.t-row { display: flex; justify-content: space-between; align-items: center; padding: var(--inv-trow-pad, 7px 14px); font-size: var(--inv-trow-size, 0.9em); color: #4a5568; border-bottom: 1px solid #edf2f7; gap: 12px; }
.t-row:last-child { border-bottom: none; }
.t-row.disc  { color: #c53030; }
.t-row.grand { background: #0d7377; color: #fff; font-weight: 700; font-size: var(--inv-grand-size, 1.0em); }
.t-row.grand span { color: #fff; }
.t-row.paid  { color: #276749; font-weight: 600; background: #f0fff4; }
.t-row.due   { color: #9b2c2c; font-weight: 600; background: #fff5f5; }

.pay-section { margin-bottom: var(--inv-pay-mb, 16px); }
.pay-title   { font-size: var(--inv-pay-title, 0.68em); text-transform: uppercase; letter-spacing: 1.5px; color: #a0aec0; font-weight: 700; margin-bottom: 6px; }
.pay-item    { display: flex; justify-content: space-between; align-items: center; padding: var(--inv-pay-pad, 5px 0); border-bottom: 1px dashed #e2e8f0; font-size: 0.88em; gap: 8px; }
.pay-chip    { background: #e6fffa; color: #0d7377; border: 1px solid #b2f5ea; border-radius: 4px; padding: var(--inv-chip-pad, 2px 9px); font-size: 0.78em; font-weight: 600; }

.ftr         { text-align: center; padding: var(--inv-ftr-pad, 14px 32px); background: #f7fafc; border-top: 1px solid #e2e8f0; }
.ftr p       { font-size: var(--inv-ftr-size, 0.82em); color: #718096; line-height: 1.6; }
.ftr .powered{ font-size: 0.72em; color: #a0aec0; margin-top: 4px; }

@media print {
  body  { background: #fff; padding: 0; }
  .card { box-shadow: none; border: none; border-radius: 0; width: 100% !important; }
  @page { size: var(--inv-page-size, A4); margin: 0; }
}
`;
